import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import ToggleSwitch from '@components/ToggleSwitch';

const SwitchSelectDescribe : React.FC<IProps> = (props) => {
  let { onShowSelectDescribe, editorStatus} = useContext(Context);
  
  return (
    <S.Root style={props.style}>
      <S.Label>Select & Describe</S.Label>
      <ToggleSwitch id="checkbox" onChange={()=>onShowSelectDescribe(!editorStatus.showSelectDescribe)} checked={!editorStatus.showSelectDescribe} style={{ display: "inline-block" }}/>
      <S.Label>Editor</S.Label>
    </S.Root>
  );
}

export default SwitchSelectDescribe;